import React from "react";
import { Row, Col } from "react-bootstrap";
import StatsKpiCard from "./StatsKpiCard";
import { formatGnf } from "./statsChartSetup";

const StatsTabRecents = ({ data, joursRecents }) => {
  if (!data) return null;
  const r = data.kpis.recents;
  const tous = data.kpis.tous;

  const pctLignes = tous.nb_lignes
    ? Math.round((r.nb_lignes / tous.nb_lignes) * 100)
    : 0;

  return (
    <div className="stats-tab-content">
      <div className="stats-alert-info mb-4">
        {joursRecents === 0 ? (
          <>
            <strong>Toutes les lignes</strong> de salaire du périmètre filtré (année / mois),
            sans restriction sur la date d&apos;enregistrement.
          </>
        ) : (
          <>
            Lignes de salaire <strong>créées</strong> dans les{" "}
            <strong>{joursRecents} derniers jours</strong> (selon la date d&apos;enregistrement),
            toujours dans le périmètre année / mois filtré.
          </>
        )}
      </div>

      <Row className="g-3 mb-4">
        <Col sm={6} lg={3}>
          <StatsKpiCard
            label="Lignes ajoutées"
            value={r.nb_lignes}
            variant="accent"
            sub={`${pctLignes}% du total filtré`}
          />
        </Col>
        <Col sm={6} lg={3}>
          <StatsKpiCard label="Net des ajouts" value={formatGnf(r.salaire_net_total)} unit="GNF" variant="primary" />
        </Col>
        <Col sm={6} lg={3}>
          <StatsKpiCard label="Employés concernés" value={r.nb_employes} variant="slate" />
        </Col>
        <Col sm={6} lg={3}>
          <StatsKpiCard label="Périodes touchées" value={r.nb_periodes} variant="indigo" />
        </Col>
      </Row>

      <Row className="g-3">
        <Col md={6}>
          <div className="stats-panel">
            <h6 className="stats-panel-title">Détail financier (ajouts récents)</h6>
            <ul className="stats-detail-list">
              <li><span>Gains</span><strong>{formatGnf(r.total_gains)} GNF</strong></li>
              <li><span>Charge salariale</span><strong>{formatGnf(r.total_charge_salariale)} GNF</strong></li>
              <li><span>Charge patronale</span><strong>{formatGnf(r.total_charge_patronale)} GNF</strong></li>
              <li><span>CNSS employé</span><strong>{formatGnf(r.cnss_employe)} GNF</strong></li>
              <li><span>CNSS patronale</span><strong>{formatGnf(r.cnss_patronale)} GNF</strong></li>
            </ul>
          </div>
        </Col>
        <Col md={6}>
          <div className="stats-panel">
            <h6 className="stats-panel-title">Statut des périodes récentes</h6>
            <div className="stats-mini-grid">
              <div className="stats-mini-item success">
                <span className="n">{r.nb_periodes_verrouillees}</span>
                <span className="l">Déjà verrouillées</span>
              </div>
              <div className="stats-mini-item warning">
                <span className="n">{r.nb_periodes_ouvertes}</span>
                <span className="l">Encore ouvertes</span>
              </div>
            </div>
            <p className="stats-hint mt-3 mb-0">
              Une ligne « récente » sur une période déjà verrouillée peut indiquer une saisie
              tardive avant validation définitive.
            </p>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default StatsTabRecents;
